declare namespace $ {

	type $mol_view__sub_bog_smalljs_course_1 = $mol_type_enforce<
		ReturnType< $bog_smalljs_course['lesson_links'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_bog_smalljs_course_2 = $mol_type_enforce<
		ReturnType< $bog_smalljs_course['lesson_md'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_bog_smalljs_course_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_bog_smalljs_course_4 = $mol_type_enforce<
		ReturnType< $bog_smalljs_course['prev_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_course_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_button_minor__click_bog_smalljs_course_6 = $mol_type_enforce<
		ReturnType< $bog_smalljs_course['toggle_solution'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_course_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_link__arg_bog_smalljs_course_8 = $mol_type_enforce<
		ReturnType< $bog_smalljs_course['next_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_course_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_course_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_bog_smalljs_course_11 = $mol_type_enforce<
		ReturnType< $bog_smalljs_course['solution_md'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_bog_smalljs_course_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_course_13 = $mol_type_enforce<
		ReturnType< $bog_smalljs_course['editor_host'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_bog_smalljs_course_14 = $mol_type_enforce<
		ReturnType< $bog_smalljs_course['lesson_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_course_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $bog_smalljs_playground__store_scope_bog_smalljs_course_16 = $mol_type_enforce<
		ReturnType< $bog_smalljs_course['editor_store_key'] >
		,
		ReturnType< $bog_smalljs_playground['store_scope'] >
	>
	type $bog_smalljs_playground__seed_tree_bog_smalljs_course_17 = $mol_type_enforce<
		ReturnType< $bog_smalljs_course['editor_seed_tree'] >
		,
		ReturnType< $bog_smalljs_playground['seed_tree'] >
	>
	type $bog_smalljs_playground__seed_ts_bog_smalljs_course_18 = $mol_type_enforce<
		ReturnType< $bog_smalljs_course['editor_seed_ts'] >
		,
		ReturnType< $bog_smalljs_playground['seed_ts'] >
	>
	export class $bog_smalljs_course extends $mol_view {
		lesson_links( ): readonly(any)[]
		Lesson_list( ): $mol_view
		Instruction( ): $mol_text
		Status( ): $mol_view
		prev_arg( ): Record<string, any>
		prev_label( ): string
		Prev( ): $mol_link
		toggle_solution( next?: any ): any
		Solution_btn( ): $mol_button_minor
		next_arg( ): Record<string, any>
		next_label( ): string
		Next( ): $mol_link
		Controls( ): $mol_view
		Solution_block( ): $mol_text
		Aside( ): $mol_view
		editor_host( ): readonly(any)[]
		Editor_host( ): $mol_view
		lesson_arg( id: any): Record<string, any>
		lesson_link_label( id: any): string
		lesson( ): string
		solution_shown( next?: boolean ): boolean
		editor_seed_tree( id: any): string
		editor_seed_ts( id: any): string
		editor_store_key( id: any): string
		lesson_md( ): string
		status_text( ): string
		status_ok( ): string
		status_todo( ): string
		solution_label( ): string
		solution_show( ): string
		solution_hide( ): string
		solution_md( ): string
		sub( ): readonly(any)[]
		Lesson_link( id: any): $mol_link
		Editor( id: any): $bog_smalljs_playground
	}
	
}

//# sourceMappingURL=course.view.tree.d.ts.map